import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import router from "./router";
import "./css/global.less";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

import { monitorZoom } from "../src/utils/monitorZoom.js";
const m = monitorZoom();
if (window.screen.width > 768) {
  if (window.screen.width * window.devicePixelRatio >= 3840) {
    document.body.style.zoom = 100 / (Number(m) / 2); // 屏幕为 4k 时
  } else {
    document.body.style.zoom = 100 / Number(m);
  }
}

// import axios from 'axios'//引入axios
// Vue.prototype.$axios = axios;//把axios挂载到vue上

// 引入api请求接口
import API from "../src/api";
// 挂载在原型上
Vue.prototype.$API = API;

new Vue({
  render: (h) => h(App),
  router: router,
}).$mount("#app");
